import { useState, useCallback } from "react";
import { useDispatch,useSelector } from "react-redux";
import { deleteQuickAlert } from "./deleteQuickAlertSlice";
import useNotification from "../../../../components/notification/useNotification";
import { isSuccessResponse } from "../../../../common/utils";
import {selector as deleteQuickAlertSelector} from "./deleteQuickAlertSlice";
import { useSpinner } from "../../../../customHooks";

export const useDeleteQuickAlert = (alertId: string, onDeleteSuccess: () => void) => {
  const dispatch: any = useDispatch();
  const [showModel, setShowModel] = useState<boolean>(false);
  const deleteQuickAlertResponse = useSelector(deleteQuickAlertSelector);
  useSpinner(deleteQuickAlertResponse.status);
  const handleClose = useCallback(() => {
    setShowModel(false);
  }, []);

  const handleShow = useCallback(() => {
    setShowModel(true);
  }, []);

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

    const handleDeleteButtonClick = useCallback(() => {
      dispatch(deleteQuickAlert({ alertId })).then((response: any) => {
        if (isSuccessResponse(response.payload)) {
          showSuccessNotification(response.payload.message);
          onDeleteSuccess();
          setShowModel(false);
        } else {
          showWarningNotification(
            response.payload.response?.data?.message ||
              "Failed to delete quick alert"
          );
        }
      });
    }, [
      alertId,
      dispatch,
      showSuccessNotification,
      showWarningNotification,
      onDeleteSuccess,
    ]);
    

  return {
    handleDeleteButtonClick,
    showModel,
    handleShow,
    handleClose,
  };
};
